module.exports = "/default/images/vendor/lightgallery.js/dist/vimeo-play.png?699d005153517ee4264615dd1e4e2b64";


//////////////////
// WEBPACK FOOTER
// ./node_modules/lightgallery.js/dist/img/vimeo-play.png
// module id = 7j8G
// module chunks = 0